















import { Validator } from "vee-validate";

import {
  Vue,
  Component,
  Prop,
  Inject
} from "@/shared/vuepack";

@Component
export default class Widget extends Vue {
  @Inject()
  $validator: Validator;

  @Prop()
  title: string;

  @Prop()
  hideOnMobile: boolean;

  @Prop()
  hasShadow: boolean;

  @Prop()
  headerClass: string;

  @Prop()
  containerClass: string;

  get hasHeaderContent (): boolean {
    return !!this.$slots["widget-header"];
  }
}
